"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialChatMessages = exports.CHAT_COMPLETION_URL = void 0;
exports.CHAT_COMPLETION_URL = '/openai/chat_completion';
var types_1 = require("./types");
var initialChatMessages = [
    {
        id: 1,
        role: types_1.Role.ASSISTANT,
        chatMessageText: 'Welcome to AI Chat! I am your assistant - please ask me questions according to the instructions given.',
        status: types_1.Status.OK,
    },
];
exports.initialChatMessages = initialChatMessages;
